import styled, { css } from 'styled-components'
import { Text, Colors } from 'vvs-uikit'
import { UnderlineProps } from 'vvs-uikit/dist/components/Link/underline'

export const StyledTextWithUrl = styled(Text)<{
  isBold?: boolean
  isInline?: boolean
  linkColor?: keyof Colors
  linkUnderline?: UnderlineProps['underline']
}>`
  > a {
    font-weight: ${({ isBold }) => (isBold ? 600 : 400)};
    ${({ isInline }) =>
      isInline &&
      css`
        display: inline;
      `}
    color: ${({ linkColor }) => linkColor ?? 'inherit'};
    ${({ linkUnderline }) => css`
      ${linkUnderline !== 'none' &&
      (linkUnderline === 'always'
        ? `text-decoration: underline;`
        : `
            &:hover {
              text-decoration: underline;
            }
          `)}
    `}
  }
`
